module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"home":"Accueil"},"en":{"home":"Home"},"de":{"home":"Home"},"es":{"home":"Principal"},"it":{"home":"Homepage"},"nl":{"home":"Home"},"pt":{"home":"Principal"}}')
  delete Component.options._Ctor
}
